// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Layout from '@/layout';
var imhomepage = {
  path: '/IMhomepage',
  component: Layout,
  redirect: '/IMhomepage/advertising',
  name: 'IMhomepage',
  alwaysShow: true,
  meta: {
    title: '首页管理',
    icon: 'clipboard'
  },
  children: [{
    path: 'advertising',
    component: function component() {
      return import('@/views/IMhomepage/advertising/index');
    },
    name: 'advertising',
    meta: {
      title: '桌面端广告'
    }
  }, {
    path: 'adedit',
    component: function component() {
      return import('@/views/IMhomepage/advertising/edit');
    },
    name: 'adedit',
    meta: {
      title: '新增广告'
    }
  }]
};
export default imhomepage;